<template>
  <section class="app-main">
    <keep-alive>
      <transition v-if="$route.meta.keepAlive" name="fade-transform" mode="out-in">
        <router-view class="section" :key="key" />
      </transition>
    </keep-alive>
    <transition v-if="!$route.meta.keepAlive" name="fade-transform" mode="out-in">
      <router-view class="section" :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="stylus" scoped>
.app-main {
  width: 100%;
  position: relative;
  /* overflow: hidden; */
  flex: 1;
  background: #F9F9F9;
  display flex
  flex-direction column
}

.section {
  flex: 1;
}
</style>
